export const ADMIN_ROLE = 'Administrator';
export const CLIENT_ROLE = 'Client';
